'use client'
import React from 'react';

const ShimmerNewsList: React.FC<{count: number}> = ({count}) => {
// Define a reusable shimmer placeholder element
  // The 'animate-shimmer' class comes from tailwind.config.js
  const ShimmerPlaceholder = ({ className }: { className?: string }) => (
    <div
      className={`bg-gray-200 relative overflow-hidden rounded
            before:absolute before:inset-0 before:-translate-x-full
            before:bg-gradient-to-r before:from-gray-200 before:via-gray-300 before:to-gray-200
            before:w-full before:h-full animate-pulse before:animate-[shimmer_1.5s_infinite] ${className}`}
    ></div>
  );

  return (
    <div className="w-full max-w-md mx-auto py-2">
      {Array.from({ length: count }).map((_, index) => ( // Render 8 shimmer items
        <div key={index} className="flex items-start bg-white p-3 border-b border-gray-200 last:border-b-0">
          {/* Thumbnail Shimmer */}
          <ShimmerPlaceholder className="flex-shrink-0 w-[25%] h-20 rounded-md mr-3" />

          {/* Headline Shimmer */}
          <div className="flex-1 flex flex-col justify-center space-y-2">
            <ShimmerPlaceholder className="h-4 w-11/12 rounded" />
            <ShimmerPlaceholder className="h-4 w-10/12 rounded" />
            <ShimmerPlaceholder className="h-4 w-8/12 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ShimmerNewsList;